import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import Toast from "../../components/Toast/Toast.jsx";
import HiringForm from "./Components/HiringForm";
import IMG from "../../assets/4.png";
import CONTACTUS from "../../assets/hiring.png";

const Hiring = ({ content }) => {
  const [captchaValue, setCaptchaValue] = useState("");
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (values) => {
    if (process.env.REACT_APP_RECAPTCHA_ENABLER === "true") {
      // First check if captcha value is empty
      if (!captchaValue) {
        toast.error("Please complete the reCAPTCHA verification.");
        return;
      }
      else if (! await verifiyCaptcha(captchaValue)) {
        toast.error("Please verify reCAPTCHA");
        return;
      }
    }

    setIsLoading(true);

    let payload = {
      ...values,
    };

    const formData = new FormData();
    formData.append("name", payload.name);
    formData.append("phone_number", payload.phone_number);
    if (payload.email) formData.append("email", payload.email);
    formData.append("message", payload.message);
    formData.append("position_applying_for", payload.position_applying_for);
    if (payload.upload_cv[0])
      formData.append("upload_cv", payload.upload_cv[0]);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}hiring/hiring_now/`,
        formData
      );
      if (response.data.error) {
        toast.error("Error!");
        return;
      }
      toast.success("Application Submitted");
      setIsFormSubmitted(true);
    } catch (error) {
      toast.error(
        "Unable to send your application at this moment, please try again later",
        { id: "send-application-fail" }
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  async function verifiyCaptcha(captchaToken)
  {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}recaptcha-token/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ recaptchaToken: captchaToken }),
        }
      );
      const data = await response.json();
      return data.success;
    } catch (error) {
      console.error("Error verifying captcha:", error);
      return false;
    }
  }

  return (
    <>
      <style jsx="true">{`
        ::-webkit-scrollbar {
          width: 5px;
          border-radius: 50px;
        }

        ::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 50px;
        }

        ::-webkit-scrollbar-thumb {
          background: #888;
          border-radius: 50px;
        }

        ::-webkit-scrollbar-thumb:hover {
          background: #555;
          border-radius: 50px;
        }

        .hiring-back {
          background-image: url(${IMG});
          background-size: cover;
          background-position: center;
          height: 100%;

          .hiring-content {
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
            padding-top: 4rem;

            .hiring-heading {
              color: #68755c;
              font-weight: bold;
              margin-bottom: 5px;
            }

            .hiring-line {
              width: 5%;
            }

            .hiring-para {
              font-size: 1vw;
              font-weight: 500;
            }

            .hiring-form {
              width: 88%;
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              margin: 25px 0px 50px 0px;

              .submitted-text {
                color: #869672;
                font-size: 1.6vw;
                font-weight: bold;
              }

              .hiring-image-class {
                display: flex;
                justify-content: center;
                align-items: center;

                .hiring-img {
                  width: 83%;
                  height: 100%;
                  object-fit: cover;
                }
              }
            }

            @media screen and (max-width: 768px) {
              .hiring-para {
                font-size: 3vw;
                margin-bottom: 30px;
              }

              .hiring-line {
                width: 10%;
              }

              .hiring-form {
                width: 90%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 50px;

                .submitted-text {
                  font-size: 5vw;
                  margin-bottom: 25px;
                }

                .hiring-image-class {
                  .hiring-img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    margin-bottom: 10%;
                  }
                }
              }
            }
          }
        }
      `}</style>

      <div className="hiring-back">
        <div className="container">
          <div className="hiring-content">
            <h1 className="hiring-heading">{content[0].description}</h1>
            <hr className="hiring-line" />
            <p className="hiring-para col-md-10">{content[1].description}</p>
            <div className="hiring-form">
              <p className="hiring-image-class col-md-6">
                <img src={CONTACTUS} alt="" className="hiring-img" />
              </p>
              {!isFormSubmitted ? (
                <HiringForm
                  setCaptchaValue={setCaptchaValue}
                  onSubmit={onSubmit}
                  isLoading={isLoading}
                  content={content[3].description}
                />
              ) : (
                <div className="submitted-text">{content[2].description}</div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Toast />
    </>
  );
};

export default Hiring;
